import { library } from "@fortawesome/fontawesome-svg-core"
import {
	faBars,
	faCheck,
	faCircle,
	faCirclePlay,
	faCopy,
	faDownload,
	faEnvelope,
	faFilter,
	faLink,
	faMusic,
	faPause,
	faPhone,
	faPlay,
	faPlus,
	faPlusCircle,
	faSearch,
	faSpinner,
	faStop,
	faThumbsUp,
	faTimes,
	faVolumeHigh,
	faVolumeLow,
	faVolumeXmark
} from "@fortawesome/pro-solid-svg-icons";
import {
	faCircle as faCircleRegular,
	faFileMusic as faFileMusicRegular,
	faPlusCircle as faPlusCircleRegular
} from "@fortawesome/pro-regular-svg-icons";
import {
	faFacebook,
	faImdb,
	faPatreon,
	faPaypal,
	faSoundcloud,
	faSpotify,
	faYoutube
} from "@fortawesome/free-brands-svg-icons";

const setupIcons = () => {
	library.add(
		faBars,
		faCheck,
		faCircle,
		faCirclePlay,
		faCircleRegular,
		faCopy,
		faDownload,
		faEnvelope,
		faFacebook,
		faFileMusicRegular,
		faFilter,
		faImdb,
		faLink,
		faMusic,
		faPatreon,
		faPaypal,
		faPause,
		faPhone,
		faPlay,
		faPlus,
		faPlusCircle,
		faPlusCircleRegular,
		faSearch,
		faSpinner,
		faSoundcloud,
		faSpotify,
		faStop,
		faThumbsUp,
		faTimes,
		faVolumeHigh,
		faVolumeLow,
		faVolumeXmark,
		faYoutube,
	);
};

export default setupIcons;